import {
  getMinIntersectionRatio,
  getMinIntersectionWidthHeight,
  intersectionMap,
  intersectionObserver,
  isIntersectionValid,
} from './IntersectionObserver';
import {attributeFilter, nodeAddedMap} from './MutationHandler';
import {isHTMLElement} from './utils';

const attribute = 'data-intersection-events';

export const IntersectionEventController = Object.freeze({
  attribute,
  selector: `[${attribute}]`,
});

intersectionMap.set(IntersectionEventController.selector, (entry) => {
  const {target} = entry;
  if (
    !target.matches(IntersectionEventController.selector) ||
    !isHTMLElement(target)
  ) {
    return;
  }

  const event = Object.assign(new Event('intersectionchange'), {
    entry,
    minIntersectionRatio: getMinIntersectionRatio(target),
    minIntersectionWidthHeight: getMinIntersectionWidthHeight(target),
    isValid: isIntersectionValid(entry),
  });
  target.dispatchEvent(event);
});

nodeAddedMap.set(IntersectionEventController.selector, (target) => {
  if (!target.matches(IntersectionEventController.selector)) {
    return;
  }

  intersectionObserver.observe(target);
});

attributeFilter.add(attribute);
